<div class="row">
    <div class="col-xl-3 col-md-6">
        <div class="card px-3 pt-3 mb-5">
            <div class="d-flex justify-content-between">
                <div class="pr-5 flex-grow-1 text-nowrap">
                    <div class="text-uppercase font-weight-bold font-size-xs mb-2">
                        Customers
                    </div>
                    <div class="font-weight-bold">
                        <div class="font-size-xxl mb-1">345</div>
                        <div class="text-success">
                            <span>54%</span>
                            <fa-icon [icon]="['fas', 'angle-up']" class="ml-2"></fa-icon>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center pt-2 px-3">
                    <apx-chart
                            [chart]="{
                                        type: 'bar',
                                        height: 104,
                                        sparkline: {
                                            enabled: true
                                        }
                                    }"
                            [colors]="['#f4772e']"
                            [markers]="{
                                        size: 0
                                    }"
                            [series]="[
                                      {
                                        name: 'Orders',
                                        data: [47, 38, 56, 24, 56, 24, 65]
                                      }
                                    ]"
                            [stroke]="{
                                            color: '#4191ff',
                                            width: 0
                                    }"
                            [xaxis]="{
                                        crosshairs: {
                                            width: 0
                                        }
                                    }"
                            [yaxis]="{
                                        min: 0
                                    }"
                    ></apx-chart>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-3 col-md-6">
        <div class="card pl-3 pt-3 mb-5">
            <div class="d-flex justify-content-between">
                <div class="pr-5 flex-grow-1 text-nowrap">
                    <div class="text-uppercase font-weight-bold font-size-xs mb-2">
                        Orders
                    </div>
                    <div class="font-weight-bold">
                        <div class="font-size-xxl mb-1">54</div>
                        <div class="text-success">
                            <span>67%</span>
                            <fa-icon [icon]="['fas', 'angle-up']" class="ml-2"></fa-icon>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center pt-2">
                    <apx-chart
                            [chart]="{
                                        type: 'area',
                                        height: 104,
                                        sparkline: {
                                            enabled: true
                                        }
                                    }"
                            [colors]="['#11c5db']"
                            [markers]="{
                                        size: 0
                                    }"
                            [series]="[
                                      {
                                        name: 'Orders',
                                        data: [ 0, 10, 22,46,47, 26, 24, 45]
                                      }
                                    ]"
                            [stroke]="{
                                            color: '#11c5db',
                                            width: 3
                                    }"
                            [xaxis]="{
                                        crosshairs: {
                                            width: 0
                                        }
                                    }"
                            [yaxis]="{
                                        min: 0
                                    }"
                    ></apx-chart>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-3 col-md-6">
        <div class="card px-3 pt-3 mb-5">
            <div class="d-flex justify-content-between">
                <div class="pr-5 flex-grow-1 text-nowrap">
                    <div class="text-uppercase font-weight-bold font-size-xs mb-2">
                        Growth
                    </div>
                    <div class="font-weight-bold">
                        <div class="font-size-xxl mb-1">$456</div>
                        <div class="text-danger">
                            <span>32%</span>
                            <fa-icon [icon]="['fas', 'angle-down']" class="ml-2"></fa-icon>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center pt-2 px-3">
                    <apx-chart
                            [chart]="{
                                        type: 'bar',
                                        height: 104,
                                        sparkline: {
                                            enabled: true
                                        }
                                    }"
                            [colors]="['#1bc943']"
                            [markers]="{
                                        size: 0
                                    }"
                            [series]="[
                                      {
                                        name: 'Orders',
                                        data: [ 38, 43, 24, 56, 35, 56, 65]
                                      }
                                    ]"
                            [stroke]="{
                                            color: '#1bc943',
                                            width: 3
                                    }"
                            [xaxis]="{
                                        crosshairs: {
                                            width: 0
                                        }
                                    }"
                            [yaxis]="{
                                        min: 0
                                    }"
                    ></apx-chart>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-3 col-md-6">
        <div class="card pl-3 pt-3 mb-5">
            <div class="d-flex justify-content-between">
                <div class="pr-5 flex-grow-1 text-nowrap">
                    <div class="text-uppercase font-weight-bold font-size-xs mb-2">
                        Expenses
                    </div>
                    <div class="font-weight-bold">
                        <div class="font-size-xxl mb-1">$674</div>
                        <div class="text-danger">
                            <span>21%</span>
                            <fa-icon [icon]="['fas', 'angle-down']" class="ml-2"></fa-icon>
                        </div>
                    </div>
                </div>
                <div class="d-flex align-items-center pt-2">
                    <apx-chart
                            [chart]="{
                                        type: 'area',
                                        height: 104,
                                        sparkline: {
                                            enabled: true
                                        }
                                    }"
                            [colors]="['#4191ff']"
                            [markers]="{
                                        size: 0
                                    }"
                            [series]="[
                                      {
                                        name: 'Orders',
                                        data: [0, 7, 18, 28, 23, 24, 65, 43 ]
                                      }
                                    ]"
                            [stroke]="{
                                            color: '#4191ff',
                                            width: 3
                                    }"
                            [xaxis]="{
                                        crosshairs: {
                                            width: 0
                                        }
                                    }"
                            [yaxis]="{
                                        min: 0
                                    }"
                    ></apx-chart>
                </div>
            </div>
        </div>
    </div>
</div>